import type { User } from '../../types';
import { formatOU } from '../../utils/dn';
import { UserAvatar } from '../photo/UserAvatar';

interface UserCardProps {
  user: User;
}

export function UserCard({ user }: UserCardProps) {
  const ouPath = formatOU(user.onPremisesDistinguishedName);

  return (
    <div className="flex items-center gap-4 border border-rule bg-bg p-4">
      <UserAvatar userId={user.id} displayName={user.displayName} size="md" />

      <div className="min-w-0 flex-1">
        <p className="truncate text-lg font-semibold text-ink">
          {user.displayName}
        </p>

        {(user.jobTitle ?? user.department) && (
          <p className="truncate text-sm text-muted">
            {[user.jobTitle, user.department].filter(Boolean).join(' · ')}
          </p>
        )}

        {ouPath && (
          <p
            className="truncate text-xs text-muted-soft"
            title={user.onPremisesDistinguishedName ?? undefined}
          >
            {ouPath}
          </p>
        )}

        <p className="mono mt-0.5 truncate text-xs text-muted-soft">
          {user.userPrincipalName}
        </p>

        {user.mail && user.mail !== user.userPrincipalName && (
          <p className="truncate text-xs text-muted-soft">{user.mail}</p>
        )}
      </div>
    </div>
  );
}
